(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 70277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgChevronRight = function SvgChevronRight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgChevronRight);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjI5Mjg5IDUuMjkyODlDOC42ODM0MiA0LjkwMjM3IDkuMzE2NTggNC45MDIzNyA5LjcwNzExIDUuMjkyODlMMTUuNzA3MSAxMS4yOTI5QzE2LjA5NzYgMTEuNjgzNCAxNi4wOTc2IDEyLjMxNjYgMTUuNzA3MSAxMi43MDcxTDkuNzA3MTEgMTguNzA3MUM5LjMxNjU4IDE5LjA5NzYgOC42ODM0MiAxOS4wOTc2IDguMjkyODkgMTguNzA3MUM3LjkwMjM3IDE4LjMxNjYgNy45MDIzNyAxNy42ODM0IDguMjkyODkgMTcuMjkyOUwxMy41ODU4IDEyTDguMjkyODkgNi43MDcxMUM3LjkwMjM3IDYuMzE2NTggNy45MDIzNyA1LjY4MzQyIDguMjkyODkgNS4yOTI4OVoiIC8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 7556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCircleXFilled = function SvgCircleXFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47718 2 2.00002 6.47715 2.00002 12C2.00002 17.5228 6.47718 22 12 22C17.5229 22 22 17.5228 22 12C22 6.47715 17.5229 2 12 2ZM15.2796 8.72018C15.7066 9.14711 15.7066 9.83931 15.2796 10.2663L13.5459 12L15.2796 13.7337C15.7066 14.1606 15.7066 14.8528 15.2796 15.2798C14.8527 15.7067 14.1605 15.7067 13.7336 15.2798L11.9998 13.546L10.2663 15.2796C9.83934 15.7065 9.14714 15.7065 8.7202 15.2796C8.29327 14.8527 8.29326 14.1605 8.7202 13.7335L10.4538 12L8.7202 10.2664C8.29326 9.83948 8.29326 9.14728 8.7202 8.72034C9.14714 8.29341 9.83934 8.29341 10.2663 8.72034L11.9998 10.4539L13.7336 8.72018C14.1605 8.29324 14.8527 8.29324 15.2796 8.72018Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgCircleXFilled);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyQzYuNDc3MTggMiAyLjAwMDAyIDYuNDc3MTUgMi4wMDAwMiAxMkMyLjAwMDAyIDE3LjUyMjggNi40NzcxOCAyMiAxMiAyMkMxNy41MjI5IDIyIDIyIDE3LjUyMjggMjIgMTJDMjIgNi40NzcxNSAxNy41MjI5IDIgMTIgMlpNMTUuMjc5NiA4LjcyMDE4QzE1LjcwNjYgOS4xNDcxMSAxNS43MDY2IDkuODM5MzEgMTUuMjc5NiAxMC4yNjYzTDEzLjU0NTkgMTJMMTUuMjc5NiAxMy43MzM3QzE1LjcwNjYgMTQuMTYwNiAxNS43MDY2IDE0Ljg1MjggMTUuMjc5NiAxNS4yNzk4QzE0Ljg1MjcgMTUuNzA2NyAxNC4xNjA1IDE1LjcwNjcgMTMuNzMzNiAxNS4yNzk4TDExLjk5OTggMTMuNTQ2TDEwLjI2NjMgMTUuMjc5NkM5LjgzOTM0IDE1LjcwNjUgOS4xNDcxNCAxNS43MDY1IDguNzIwMiAxNS4yNzk2QzguMjkzMjcgMTQuODUyNyA4LjI5MzI2IDE0LjE2MDUgOC43MjAyIDEzLjczMzVMMTAuNDUzOCAxMkw4LjcyMDIgMTAuMjY2NEM4LjI5MzI2IDkuODM5NDggOC4yOTMyNiA5LjE0NzI4IDguNzIwMiA4LjcyMDM0QzkuMTQ3MTQgOC4yOTM0MSA5LjgzOTM0IDguMjkzNDEgMTAuMjY2MyA4LjcyMDM0TDExLjk5OTggMTAuNDUzOUwxMy43MzM2IDguNzIwMThDMTQuMTYwNSA4LjI5MzI0IDE0Ljg1MjcgOC4yOTMyNCAxNS4yNzk2IDguNzIwMThaIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 78975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C11.8487 18 13.551 17.3729 14.9056 16.3199L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L16.3199 14.9056C17.3729 13.551 18 11.8487 18 10C18 5.58172 14.4183 2 10 2Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgSearch);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDEwQzQgNi42ODYyOSA2LjY4NjI5IDQgMTAgNEMxMy4zMTM3IDQgMTYgNi42ODYyOSAxNiAxMEMxNiAxMy4zMTM3IDEzLjMxMzcgMTYgMTAgMTZDNi42ODYyOSAxNiA0IDEzLjMxMzcgNCAxMFpNMTAgMkM1LjU4MTcyIDIgMiA1LjU4MTcyIDIgMTBDMiAxNC40MTgzIDUuNTgxNzIgMTggMTAgMThDMTEuODQ4NyAxOCAxMy41NTEgMTcuMzcyOSAxNC45MDU2IDE2LjMxOTlMMjAuMjkyOSAyMS43MDcxQzIwLjY4MzQgMjIuMDk3NiAyMS4zMTY2IDIyLjA5NzYgMjEuNzA3MSAyMS43MDcxQzIyLjA5NzYgMjEuMzE2NiAyMi4wOTc2IDIwLjY4MzQgMjEuNzA3MSAyMC4yOTI5TDE2LjMxOTkgMTQuOTA1NkMxNy4zNzI5IDEzLjU1MSAxOCAxMS44NDg3IDE4IDEwQzE4IDUuNTgxNzIgMTQuNDE4MyAyIDEwIDJaIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 64359:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(40342);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Blog": function() { return /* binding */ Blog; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/utils/src/lib/helpers.ts
var helpers = __webpack_require__(44386);
// EXTERNAL MODULE: ../../libs/utils/src/lib/website/website-strapi.ts
var website_strapi = __webpack_require__(82185);
// EXTERNAL MODULE: ../../node_modules/slugify/slugify.js
var slugify = __webpack_require__(76854);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-update-header.tsx
var use_update_header = __webpack_require__(41898);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/utils/constants.ts + 14 modules
var constants = __webpack_require__(68579);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/hooks/use-clean-header.tsx
var use_clean_header = __webpack_require__(90573);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/seo/index.tsx
var seo = __webpack_require__(25352);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/assets/icons/clock.svg
var clock = __webpack_require__(5192);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/tag/index.tsx
var components_tag = __webpack_require__(69565);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/pink-graph-element.svg
var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgPinkGraphElement = function SvgPinkGraphElement(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 300,
    height: 350,
    viewBox: "0 0 300 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_6377_20260)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M14.7157 193.65H0L10.5747 143.175H25.2904L14.7157 193.65Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M167.008 193.65H152.293L162.86 143.175H177.583L167.008 193.65Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M59.9351 159.529H45.2194L55.787 109.054H70.5098L59.9351 159.529Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M136.081 159.529H121.366L131.933 109.054H146.656L136.081 159.529Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M105.585 123.347H90.8691L101.444 72.8718H116.16L105.585 123.347Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M321.29 193.65H306.575L317.142 143.175H331.865L321.29 193.65Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M214.217 159.529H199.501L210.069 109.054H224.792L214.217 159.529Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M290.364 159.529H275.648L286.215 109.054H300.938L290.364 159.529Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M259.867 123.347H245.151L255.719 72.8718H270.442L259.867 123.347Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M479.403 193.65H464.687L475.255 143.175H489.971L479.403 193.65Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M372.33 159.529H357.614L368.182 109.054H382.897L372.33 159.529Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M448.476 159.529H433.76L444.328 109.054H459.044L448.476 159.529Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M417.98 123.347H403.264L413.831 72.8718H428.554L417.98 123.347Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M31.8652 101.683H23.033L30.4331 66.3449H39.2654L31.8652 101.683Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M184.158 101.683H175.326L182.726 66.3449H191.558L184.158 101.683Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M77.0846 69.5412H68.2524L75.6525 34.203H84.4848L77.0846 69.5412Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M153.231 69.5412H144.399L151.799 34.203H160.631L153.231 69.5412Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M122.734 35.3381H113.902L121.302 0H130.134L122.734 35.3381Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M338.44 101.683H329.608L337.008 66.3449H345.84L338.44 101.683Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M231.367 69.5412H222.534L229.935 34.203H238.767L231.367 69.5412Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M277.016 35.3381H268.184L275.584 0H284.417L277.016 35.3381Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M496.553 101.683H487.72L495.121 66.3449H503.953L496.553 101.683Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M389.479 69.5412H380.647L388.047 34.203H396.88L389.479 69.5412Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M465.626 69.5412H456.793L464.194 34.203H473.026L465.626 69.5412Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M435.129 35.3381H426.297L433.697 0H442.529L435.129 35.3381Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M135.432 353.18H120.71L131.284 302.704H146L135.432 353.18Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M28.3591 319.059H13.6364L24.2111 268.583H38.9268L28.3591 319.059Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M104.498 319.059H89.7827L100.357 268.583H115.073L104.498 319.059Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M74.0088 282.877H59.2861L69.8608 232.401H84.5765L74.0088 282.877Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M289.707 353.18H274.992L285.559 302.704H300.282L289.707 353.18Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M182.634 319.059H167.918L178.486 268.583H193.209L182.634 319.059Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M258.78 319.059H244.065L254.632 268.583H269.355L258.78 319.059Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M228.284 282.877H213.568L224.143 232.401H238.859L228.284 282.877Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M447.82 353.18H433.104L443.672 302.704H458.395L447.82 353.18Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M340.747 319.059H326.031L336.599 268.583H351.322L340.747 319.059Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M416.893 319.059H402.177L412.745 268.583H427.468L416.893 319.059Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M386.397 282.877H371.681L382.249 232.401H396.971L386.397 282.877Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M152.575 261.205H143.743L151.143 225.874H159.975L152.575 261.205Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M45.5016 229.063H36.6693L44.0695 193.732H52.9018L45.5016 229.063Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M121.648 229.063H112.816L120.216 193.732H129.048L121.648 229.063Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M91.1513 194.86H82.319L89.7192 159.529H98.5515L91.1513 194.86Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M199.784 229.063H190.951L198.352 193.732H207.184L199.784 229.063Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M275.93 229.063H267.098L274.498 193.732H283.33L275.93 229.063Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M245.433 194.86H236.601L244.001 159.529H252.834L245.433 194.86Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M464.97 261.205H456.137L463.538 225.874H472.37L464.97 261.205Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M357.896 229.063H349.064L356.464 193.732H365.296L357.896 229.063Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M434.043 229.063H425.21L432.611 193.732H441.443L434.043 229.063Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M403.546 194.86H394.714L402.114 159.529H410.946L403.546 194.86Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M498.45 319.059H483.735L494.309 268.583H509.025L498.45 319.059Z",
    fill: "#E98EAA"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M515.6 229.063H506.768L514.168 193.732H523L515.6 229.063Z",
    fill: "#E98EAA"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_6377_20260"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 300,
    height: 350,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgPinkGraphElement);

/* harmony default export */ var pink_graph_element = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(10912);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/blog/featured-article/styles.module.scss
var styles_module = __webpack_require__(30024);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/blog/featured-article/index.tsx







const FeaturedArticle = (param)=>{
    let { picture , tag , title , description , minutesRead , href  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default())["card-wrapper"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["picture-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (styles_module_default()).picture,
                    src: picture,
                    alt: "The ".concat(title, "'s article card"),
                    priority: true,
                    fill: true,
                    sizes: "100vw"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default())["card-content"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tag/* Tag */.Vp, {
                        label: tag,
                        className: (styles_module_default()).tag
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (styles_module_default())["min-read"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(clock/* ReactComponent */.r, {
                                className: (styles_module_default())["clock-icon"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    minutesRead,
                                    " min read"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (styles_module_default()).title,
                        title: title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (styles_module_default()).description,
                        title: description,
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* CTAButton */.m, {
                        className: (styles_module_default())["cta-button"],
                        size: "medium",
                        href: href,
                        prefetch: false,
                        children: "read more"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                className: (styles_module_default())["pink-graph"]
            })
        ]
    });
};
/* harmony default export */ var featured_article = ((/* unused pure expression or super */ null && (FeaturedArticle)));

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/assets/icons/chevron-right.svg
var chevron_right = __webpack_require__(70277);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/blog/category-title-button/index.module.scss
var index_module = __webpack_require__(52039);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/blog/category-title-button/index.tsx





const CategoryTitleButton = (param)=>{
    let { children , href , size ="large"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: href,
        prefetch: false,
        className: classnames_default()((index_module_default())["link-wrapper"], (index_module_default())[size]),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* ReactComponent */.r, {
                className: (index_module_default())["chevron-icon"]
            })
        ]
    });
};
/* harmony default export */ var category_title_button = ((/* unused pure expression or super */ null && (CategoryTitleButton)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/blog/article-list/index.tsx + 2 modules
var article_list = __webpack_require__(34792);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/green-graph-element.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var green_graph_element_excluded = ["title", "titleId"];
function green_graph_element_extends() { green_graph_element_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return green_graph_element_extends.apply(this, arguments); }
function green_graph_element_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = green_graph_element_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function green_graph_element_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgGreenGraphElement = function SvgGreenGraphElement(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = green_graph_element_objectWithoutProperties(_ref, green_graph_element_excluded);
  return /*#__PURE__*/react.createElement("svg", green_graph_element_extends({
    width: 464,
    height: 312,
    viewBox: "0 0 464 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M388.79 320.808C387.689 314.508 385.728 306.191 384.387 299.936C311.297 323.825 280.322 337.56 245.68 355.979C247.985 360.974 250.731 367.764 252.876 372.835C293.293 352.013 328.904 339.461 388.801 320.801L388.79 320.808Z",
    fill: "#0C423C"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M477.81 245.02C458.082 251.674 427.676 261.839 378.233 278.377C380.265 284.797 382.565 293.473 384.384 299.945C424.369 287.146 451.459 278.464 470.49 272.338L477.81 245.02Z",
    fill: "#0C423C"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M207.245 266.387C146.47 305.287 134.221 327.851 124.532 353.304C128.929 357.787 134.779 363.772 139.164 368.262C150.066 338.389 170.568 317.7 220.434 286.248C216.556 280.236 211.207 272.342 207.245 266.387Z",
    fill: "#0C423C"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M381.037 241.808C378.28 234.836 374.292 225.678 371.375 218.783C293.099 247.694 259.131 264.19 220.437 286.248C224.144 292.045 228.879 299.895 232.483 305.744C277.999 280.302 316.659 264.855 381.037 241.808Z",
    fill: "#0C423C"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M505.917 140.126C482.399 149.923 477.093 151.906 360.442 195.497C363.837 202.421 368.107 211.784 371.376 218.773C455.252 188.336 479.814 179.423 497.259 172.436L505.917 140.126Z",
    fill: "#0C423C"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M106.185 322.989C101.656 318.222 95.6421 311.846 91.1341 307.075C78.9423 345.018 85.1576 369.681 101.224 396.695L111.92 399.561C94.5582 368.676 99.1669 345.624 106.185 322.989Z",
    fill: "#0C423C"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M168.765 189.289C110.771 227.664 91.5124 254.682 76.281 291.116C80.7093 295.925 86.6674 302.286 91.1218 307.073C110.359 260.724 143.193 236.57 184.134 209.794C179.557 203.614 173.381 195.439 168.765 189.289Z",
    fill: "#0C423C"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M357.971 156.602C354.13 149.489 348.835 140.1 344.909 133.043C261.883 166.309 226.918 184.304 184.145 209.805C188.674 215.942 194.6 224.2 199.071 230.37C248.673 201.2 289.824 183.344 357.971 156.602Z",
    fill: "#0C423C"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M477.874 55.3522C429.113 73.7504 379.699 90.3656 331.275 109.658C335.42 116.635 340.828 126.014 344.912 133.034C393.453 113.862 442.679 96.5018 491.278 77.4846C487.382 70.7632 481.913 61.9829 477.874 55.3522Z",
    fill: "#0C423C"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M52.086 358.497C55.9608 361.927 61.2728 366.328 65.2188 369.678C41.6607 320.468 49.2339 289.019 59.8493 258.514C55.7717 253.729 50.4572 247.263 46.4408 242.435C29.7217 290.163 35.8449 321.133 52.086 358.497Z",
    fill: "#0C423C"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M34.0185 226.591C37.6632 231.399 42.6993 237.681 46.4379 242.435C67.5439 193.411 97.4079 165.821 145.148 132.043C140.928 126.197 135.437 118.314 131.287 112.428C72.2885 155.368 51.581 185.68 34.0253 226.603L34.0185 226.591Z",
    fill: "#0C423C"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M145.141 132.04C149.539 138.111 155.502 146.121 159.952 152.147C208.953 122.29 257.159 98.9989 326.345 71.7513C322.149 65.2971 316.411 56.782 312.144 50.3684C263.013 69.1139 208.777 91.9804 145.141 132.04Z",
    fill: "#0C423C"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M449.141 4.14124L410.182 -6.2978C313.049 24.7564 311.898 25.1626 298.097 30.0699C302.358 36.1346 307.937 44.2795 312.148 50.3806C357.402 33.7327 403.482 19.5591 449.148 4.15296L449.141 4.14124Z",
    fill: "#0C423C"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M467.585 22.2144C475.155 19.3394 481.638 16.7392 487.222 14.3448L455.403 5.81886C459.396 11.1069 463.967 17.3442 467.585 22.2144Z",
    fill: "#0C423C"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M13.4892 310.101C15.7429 313.544 19.0954 317.886 21.5234 321.197C1.07875 263.035 10.5015 227.535 22.8789 193.344C19.9737 188.814 16.3808 182.59 13.6165 177.979C-5.55878 230.984 -0.948 266.561 13.4892 310.101Z",
    fill: "#0C423C"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M13.6178 177.979C36.8225 124.604 68.6649 93.5936 115.841 58.0665C112.964 52.9879 109.343 46.0922 106.583 40.9458C41.5934 89.4266 21.2776 127.833 6.04148 163.026C8.14129 167.598 11.3326 173.505 13.6271 177.981L13.6178 177.979Z",
    fill: "#0C423C"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M126.674 76.3532C167.395 49.25 206.062 28.7727 293.636 -1.7562C289.825 -6.94585 284.722 -13.8316 280.9 -19.0145C189.465 11.5913 154.811 32.2408 115.842 58.0665C119.002 63.608 123.417 70.8752 126.674 76.3532Z",
    fill: "#0C423C"
  })));
};
var green_graph_element_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgGreenGraphElement);

/* harmony default export */ var green_graph_element = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/newsletter-forms/index.tsx + 2 modules
var newsletter_forms = __webpack_require__(45169);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/blog/stay-in-the-loop/styles.module.scss
var stay_in_the_loop_styles_module = __webpack_require__(79676);
var stay_in_the_loop_styles_module_default = /*#__PURE__*/__webpack_require__.n(stay_in_the_loop_styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/blog/stay-in-the-loop/index.tsx




const StayInTheLoop = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (stay_in_the_loop_styles_module_default())["main-section"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (stay_in_the_loop_styles_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (stay_in_the_loop_styles_module_default()).title,
                        children: [
                            "Stay in the ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (stay_in_the_loop_styles_module_default()).decoration,
                                children: "loop"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (stay_in_the_loop_styles_module_default()).paragraph,
                        children: "International career content straight to your inbox"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_forms/* default */.Z, {
                        className: (stay_in_the_loop_styles_module_default()).form
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(green_graph_element_ForwardRef, {
                className: (stay_in_the_loop_styles_module_default()).graph
            })
        ]
    });
};
/* harmony default export */ var stay_in_the_loop = ((/* unused pure expression or super */ null && (StayInTheLoop)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/layouts/website-layout/index.tsx + 9 modules
var website_layout = __webpack_require__(46087);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/assets/icons/arrow-down.svg
var arrow_down_path;
var arrow_down_excluded = ["title", "titleId"];
function arrow_down_extends() { arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_down_extends.apply(this, arguments); }
function arrow_down_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = arrow_down_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function arrow_down_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgArrowDown = function SvgArrowDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = arrow_down_objectWithoutProperties(_ref, arrow_down_excluded);
  return /*#__PURE__*/react.createElement("svg", arrow_down_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, arrow_down_path || (arrow_down_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.3051 14.7112L7.28981 10.683C6.67071 10.062 7.10918 9 7.98471 9H16.0153C16.8908 9 17.3293 10.062 16.7102 10.683L12.6949 14.7112C12.3111 15.0963 11.6889 15.0963 11.3051 14.7112Z"
  })));
};
var arrow_down_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgArrowDown);

/* harmony default export */ var arrow_down = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjMwNTEgMTQuNzExMkw3LjI4OTgxIDEwLjY4M0M2LjY3MDcxIDEwLjA2MiA3LjEwOTE4IDkgNy45ODQ3MSA5SDE2LjAxNTNDMTYuODkwOCA5IDE3LjMyOTMgMTAuMDYyIDE2LjcxMDIgMTAuNjgzTDEyLjY5NDkgMTQuNzExMkMxMi4zMTExIDE1LjA5NjMgMTEuNjg4OSAxNS4wOTYzIDExLjMwNTEgMTQuNzExMloiIC8+Cjwvc3ZnPgo=");
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/button/button.tsx
var button_button = __webpack_require__(79544);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/search-bar/index.tsx
var search_bar = __webpack_require__(82942);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-popover/dist/index.module.js + 30 modules
var dist_index_module = __webpack_require__(37751);
// EXTERNAL MODULE: ../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(83096);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/menu-dropdown/index.module.scss
var menu_dropdown_index_module = __webpack_require__(11429);
var menu_dropdown_index_module_default = /*#__PURE__*/__webpack_require__.n(menu_dropdown_index_module);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/components/menu-dropdown/index.tsx








const MenuDropdown = (param)=>{
    let { trigger , items , scrollLock , onOpenChangeCallback , ...rest } = param;
    const onOpenChange = (0,react.useCallback)((open)=>{
        onOpenChangeCallback === null || onOpenChangeCallback === void 0 ? void 0 : onOpenChangeCallback(open);
        if (open && scrollLock) {
            (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(document.body, {
                reserveScrollBarGap: true
            });
            return;
        }
        (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(document.body);
    }, [
        scrollLock,
        onOpenChangeCallback
    ]);
    (0,react.useEffect)(()=>{
        return ()=>{
            (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(document.body);
        };
    });
    const renderIcon = (0,react.useCallback)((icon)=>{
        const Icon = icon;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            className: (menu_dropdown_index_module_default()).icon
        });
    }, []);
    const renderContent = (0,react.useCallback)((param)=>/*#__PURE__*/ {
        let { icon , isActive , description , label , tag  } = param;
        return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (menu_dropdown_index_module_default())["label-container"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (menu_dropdown_index_module_default())["label-content"],
                            children: [
                                icon && renderIcon(icon),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()((menu_dropdown_index_module_default())["item-text"], {
                                        [(menu_dropdown_index_module_default()).highlight]: isActive
                                    }),
                                    children: label
                                })
                            ]
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (menu_dropdown_index_module_default()).description,
                            children: description
                        })
                    ]
                }),
                tag && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tag/* default */.ZP, {
                    label: tag,
                    size: "small"
                })
            ]
        });
    }, [
        renderIcon
    ]);
    const renderButton = (0,react.useCallback)((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: (menu_dropdown_index_module_default()).item,
            ...item,
            children: renderContent(item)
        }), [
        renderContent
    ]);
    const renderLink = (0,react.useCallback)((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            className: classnames_default()((menu_dropdown_index_module_default()).item, {
                [(menu_dropdown_index_module_default()).disabled]: item.disabled
            }),
            tabIndex: item.disabled ? -1 : 0,
            ...item,
            children: renderContent(item)
        }), [
        renderContent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_module/* Root */.fC, {
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Trigger */.xz, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (menu_dropdown_index_module_default())["content-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Content */.VY, {
                    ...rest,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (menu_dropdown_index_module_default()).container,
                        children: items.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (menu_dropdown_index_module_default()).group,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        section.group && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: (menu_dropdown_index_module_default())["group-title"],
                                            children: [
                                                " ",
                                                section.group
                                            ]
                                        }),
                                        section.items.map((param)=>/*#__PURE__*/ {
                                            let { label , onClick , icon , href , disabled , ...restProps } = param;
                                            return (0,jsx_runtime.jsx)("li", {
                                                className: (menu_dropdown_index_module_default())["items-container"],
                                                children: onClick ? renderButton({
                                                    label,
                                                    onClick,
                                                    icon,
                                                    disabled,
                                                    ...restProps
                                                }) : renderLink({
                                                    label,
                                                    href,
                                                    icon,
                                                    disabled,
                                                    ...restProps
                                                })
                                            }, label);
                                        })
                                    ]
                                })
                            }, "".concat(section.group, "-").concat(JSON.stringify(section.items))))
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var menu_dropdown = ((/* unused pure expression or super */ null && (MenuDropdown)));

// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/spinner/index.tsx
var spinner = __webpack_require__(9114);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/types.generated.ts
var types_generated = __webpack_require__(9432);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/graphql/website/blog-post-fragments.generated.ts
var blog_post_fragments_generated = __webpack_require__(71285);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(60431);
// EXTERNAL MODULE: ../../libs/data-access/src/lib/custom-fetcher/index.ts
var custom_fetcher = __webpack_require__(97885);
;// CONCATENATED MODULE: ../../libs/data-access/src/lib/graphql/website/get-blog-main-page.generated.ts
/* eslint-disable */ // @ts-nocheck



const GetBlogMainPageDocument = /*#__PURE__*/ "\n    query GetBlogMainPage($input: BlogMainPageQueryArgs!) {\n  getBlogMainPage(input: $input) {\n    data {\n      featuredPost {\n        post {\n          article\n          resume\n          slug\n          title\n          readingTime\n          ...GetBlogPostBySlugAuthorFragment\n          ...GetBlogPostBySlugImageFragment\n          ...GetBlogPostBySlugTagsFragment\n          ...GetBlogPostBySlugSeoFragment\n          ...GetBlogPostBySlugCategoryFragment\n        }\n      }\n      id\n    }\n  }\n}\n    ".concat(blog_post_fragments_generated/* GetBlogPostBySlugAuthorFragmentFragmentDoc */.s_, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugImageFragmentFragmentDoc */.FD, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugTagsFragmentFragmentDoc */.E6, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugSeoFragmentFragmentDoc */.mW, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugCategoryFragmentFragmentDoc */.Wj);
const useGetBlogMainPageQuery = (variables, options)=>(0,index_production.useQuery)([
        "GetBlogMainPage",
        variables
    ], (0,custom_fetcher/* customFetcher */.k)(GetBlogMainPageDocument, variables), options);
useGetBlogMainPageQuery.getKey = (variables)=>[
        "GetBlogMainPage",
        variables
    ];
const useInfiniteGetBlogMainPageQuery = (variables, options)=>{
    var _pageParam;
    return (0,index_production.useInfiniteQuery)([
        "GetBlogMainPage.infinite",
        variables
    ], (metaData)=>(0,custom_fetcher/* customFetcher */.k)(GetBlogMainPageDocument, {
            ...variables,
            ...(_pageParam = metaData.pageParam) !== null && _pageParam !== void 0 ? _pageParam : {}
        })(), options);
};
useInfiniteGetBlogMainPageQuery.getKey = (variables)=>[
        "GetBlogMainPage.infinite",
        variables
    ];
useGetBlogMainPageQuery.fetcher = (variables, options)=>(0,custom_fetcher/* customFetcher */.k)(GetBlogMainPageDocument, variables, options);

;// CONCATENATED MODULE: ../../libs/data-access/src/lib/graphql/website/get-all-blog-post-categories.generated.ts
/* eslint-disable */ // @ts-nocheck



const GetAllBlogCategoriesDocument = /*#__PURE__*/ "\n    query GetAllBlogCategories($input: BlogCategoryWithPostsQueryArgs!) {\n  getAllBlogCategoriesWithNestedPosts(input: $input) {\n    ...GetBlogCategoriesDataFragment\n    ...GetBlogCategoriesPaginationFragment\n  }\n}\n    ".concat(blog_post_fragments_generated/* GetBlogCategoriesDataFragmentFragmentDoc */.XI, "\n").concat(blog_post_fragments_generated/* GetBlogCategoriesPaginationFragmentFragmentDoc */.Mq);
const useGetAllBlogCategoriesQuery = (variables, options)=>(0,index_production.useQuery)([
        "GetAllBlogCategories",
        variables
    ], (0,custom_fetcher/* customFetcher */.k)(GetAllBlogCategoriesDocument, variables), options);
useGetAllBlogCategoriesQuery.getKey = (variables)=>[
        "GetAllBlogCategories",
        variables
    ];
const useInfiniteGetAllBlogCategoriesQuery = (variables, options)=>{
    var _pageParam;
    return (0,index_production.useInfiniteQuery)([
        "GetAllBlogCategories.infinite",
        variables
    ], (metaData)=>(0,custom_fetcher/* customFetcher */.k)(GetAllBlogCategoriesDocument, {
            ...variables,
            ...(_pageParam = metaData.pageParam) !== null && _pageParam !== void 0 ? _pageParam : {}
        })(), options);
};
useInfiniteGetAllBlogCategoriesQuery.getKey = (variables)=>[
        "GetAllBlogCategories.infinite",
        variables
    ];
useGetAllBlogCategoriesQuery.fetcher = (variables, options)=>(0,custom_fetcher/* customFetcher */.k)(GetAllBlogCategoriesDocument, variables, options);

;// CONCATENATED MODULE: ../../libs/data-access/src/lib/graphql/website/get-all-blog-categories-with-nested-posts.generated.ts
/* eslint-disable */ // @ts-nocheck



const GetAllBlogCategoriesWithNestedPostsDocument = /*#__PURE__*/ "\n    query GetAllBlogCategoriesWithNestedPosts($input: BlogCategoryWithPostsQueryArgs!) {\n  getAllBlogCategoriesWithNestedPosts(input: $input) {\n    data {\n      id\n      name\n      posts {\n        id\n        title\n        createdAt\n        resume\n        slug\n        readingTime\n        ...GetBlogPostBySlugCategoryFragment\n        ...GetBlogPostBySlugImageFragment\n      }\n      ...GetBlogCategoriesPostPaginationFragment\n    }\n    ...GetBlogCategoriesPaginationFragment\n  }\n}\n    ".concat(blog_post_fragments_generated/* GetBlogPostBySlugCategoryFragmentFragmentDoc */.Wj, "\n").concat(blog_post_fragments_generated/* GetBlogPostBySlugImageFragmentFragmentDoc */.FD, "\n").concat(blog_post_fragments_generated/* GetBlogCategoriesPostPaginationFragmentFragmentDoc */.mS, "\n").concat(blog_post_fragments_generated/* GetBlogCategoriesPaginationFragmentFragmentDoc */.Mq);
const useGetAllBlogCategoriesWithNestedPostsQuery = (variables, options)=>(0,index_production.useQuery)([
        "GetAllBlogCategoriesWithNestedPosts",
        variables
    ], (0,custom_fetcher/* customFetcher */.k)(GetAllBlogCategoriesWithNestedPostsDocument, variables), options);
useGetAllBlogCategoriesWithNestedPostsQuery.getKey = (variables)=>[
        "GetAllBlogCategoriesWithNestedPosts",
        variables
    ];
const useInfiniteGetAllBlogCategoriesWithNestedPostsQuery = (variables, options)=>{
    var _pageParam;
    return (0,index_production.useInfiniteQuery)([
        "GetAllBlogCategoriesWithNestedPosts.infinite",
        variables
    ], (metaData)=>(0,custom_fetcher/* customFetcher */.k)(GetAllBlogCategoriesWithNestedPostsDocument, {
            ...variables,
            ...(_pageParam = metaData.pageParam) !== null && _pageParam !== void 0 ? _pageParam : {}
        })(), options);
};
useInfiniteGetAllBlogCategoriesWithNestedPostsQuery.getKey = (variables)=>[
        "GetAllBlogCategoriesWithNestedPosts.infinite",
        variables
    ];
useGetAllBlogCategoriesWithNestedPostsQuery.fetcher = (variables, options)=>(0,custom_fetcher/* customFetcher */.k)(GetAllBlogCategoriesWithNestedPostsDocument, variables, options);

// EXTERNAL MODULE: ../../libs/data-access/src/lib/graphql/website/get-all-blog-posts.generated.ts
var get_all_blog_posts_generated = __webpack_require__(86367);
// EXTERNAL MODULE: ./pages/blog/index.module.scss
var blog_index_module = __webpack_require__(67797);
var blog_index_module_default = /*#__PURE__*/__webpack_require__.n(blog_index_module);
;// CONCATENATED MODULE: ./pages/blog/index.tsx











const SEO = {
    title: "Blog // Olby",
    description: "Insights on international career, remote work, productivity, work-life balance, engineering, team management and leadership."
};
const FIRST_PAGE = 1;
const INITIAL_PAGE_SIZE = 3;
const CATEGORIES_PAGE_SIZE = 6;
const MINIMUM_POSTS_PER_CATEGORY = 1;
const LATEST_NEWS_PAGE_SIZE = 6;
const PAGE_SIZE = 20;
const POSTS_BY_CATEGORY_PAGINATION = {
    sort: [
        {
            updatedAt: types_generated/* SortingDirection.Desc */.X_.Desc
        }
    ],
    pagination: {
        page: FIRST_PAGE,
        pageSize: INITIAL_PAGE_SIZE
    },
    minimumLength: MINIMUM_POSTS_PER_CATEGORY
};
const GET_BLOG_MAIN_PAGE_PAYLOAD = {
    input: {
        locale: types_generated/* Locale.En */.go.En
    }
};
const GET_ALL_BLOG_CATEGORIES_WITH_NESTED_POSTS_PAYLOAD = {
    input: {
        pagination: {
            page: FIRST_PAGE,
            pageSize: CATEGORIES_PAGE_SIZE
        },
        posts: {
            ...POSTS_BY_CATEGORY_PAGINATION,
            locale: types_generated/* Locale.En */.go.En
        }
    }
};
const GET_ALL_BLOG_POSTS_PAYLOAD = {
    input: {
        sort: [
            {
                createdAt: types_generated/* SortingDirection.Desc */.X_.Desc
            }
        ],
        pagination: {
            page: FIRST_PAGE,
            pageSize: LATEST_NEWS_PAGE_SIZE
        }
    }
};
const GET_ALL_BLOG_CATEGORIES = {
    input: {
        pagination: {
            page: FIRST_PAGE,
            pageSize: PAGE_SIZE
        },
        posts: POSTS_BY_CATEGORY_PAGINATION
    }
};
var __N_SSP = true;
const Blog = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const router = (0,next_router.useRouter)();
    const contentRef = (0,react.useRef)(null);
    const [dropdownCategoriesPage] = (0,react.useState)(FIRST_PAGE);
    const { data  } = useGetBlogMainPageQuery(GET_BLOG_MAIN_PAGE_PAYLOAD, {
        enabled: false
    });
    const featuredPost = (ref = data === null || data === void 0 ? void 0 : data.getBlogMainPage.data) === null || ref === void 0 ? void 0 : (ref1 = ref.featuredPost) === null || ref1 === void 0 ? void 0 : ref1.post;
    const categoryName = slugify_default()((featuredPost === null || featuredPost === void 0 ? void 0 : (ref2 = featuredPost.category) === null || ref2 === void 0 ? void 0 : ref2.name) || "", {
        lower: true
    });
    // Query to get categories only on More Categories Button
    const { data: categoriesData , isLoading: isLoadingCategories  } = useInfiniteGetAllBlogCategoriesQuery(GET_ALL_BLOG_CATEGORIES, {
        getNextPageParam: (lastPage)=>{
            var ref, ref1;
            if (((ref = lastPage.getAllBlogCategoriesWithNestedPosts.pagination) === null || ref === void 0 ? void 0 : ref.page) !== ((ref1 = lastPage.getAllBlogCategoriesWithNestedPosts.pagination) === null || ref1 === void 0 ? void 0 : ref1.pageCount)) {
                return {
                    input: {
                        pagination: {
                            page: FIRST_PAGE,
                            pageSize: PAGE_SIZE
                        },
                        guides: POSTS_BY_CATEGORY_PAGINATION
                    }
                };
            }
            return undefined;
        },
        enabled: false
    });
    const { data: categoriesAndArticles , fetchNextPage , isFetchingNextPage  } = useInfiniteGetAllBlogCategoriesWithNestedPostsQuery(GET_ALL_BLOG_CATEGORIES_WITH_NESTED_POSTS_PAYLOAD, {
        getNextPageParam: (lastPage)=>{
            var ref, ref1;
            const lastPageNumber = Number((ref = lastPage === null || lastPage === void 0 ? void 0 : lastPage.getAllBlogCategoriesWithNestedPosts.pagination) === null || ref === void 0 ? void 0 : ref.page);
            if (lastPageNumber < Number((ref1 = lastPage.getAllBlogCategoriesWithNestedPosts.pagination) === null || ref1 === void 0 ? void 0 : ref1.pageCount)) {
                return {
                    input: {
                        pagination: {
                            page: lastPageNumber + 1,
                            pageSize: CATEGORIES_PAGE_SIZE
                        },
                        posts: POSTS_BY_CATEGORY_PAGINATION
                    }
                };
            }
            return undefined;
        },
        enabled: false
    });
    const { data: latestNews  } = (0,get_all_blog_posts_generated/* useInfiniteGetAllBlogPostsQuery */.Ez)(GET_ALL_BLOG_POSTS_PAYLOAD, {
        enabled: false
    });
    const { register , handleSubmit , reset , formState: { dirtyFields  }  } = (0,index_esm/* useForm */.cI)({
        mode: "onSubmit",
        defaultValues: {
            search: ""
        }
    });
    const onSearchClear = ()=>{
        reset();
    };
    const onSubmit = handleSubmit((data)=>{
        if (dirtyFields.search) {
            router.push({
                pathname: "/blog/search-results",
                query: {
                    searchPosts: data.search
                }
            });
        }
    });
    const { highlightedCategories , moreOptions  } = (0,react.useMemo)(()=>{
        const formattedCategories = (0,helpers/* formatPostsCategory */.Av)(categoriesData === null || categoriesData === void 0 ? void 0 : categoriesData.pages[dropdownCategoriesPage - FIRST_PAGE].getAllBlogCategoriesWithNestedPosts.data);
        return {
            moreOptions: {
                items: [
                    {
                        items: formattedCategories === null || formattedCategories === void 0 ? void 0 : formattedCategories.moreOptionsCategories
                    }
                ]
            },
            highlightedCategories: formattedCategories === null || formattedCategories === void 0 ? void 0 : formattedCategories.highlightedCategories
        };
    }, [
        categoriesData,
        dropdownCategoriesPage
    ]);
    const latestNewsSectionPosts = (0,react.useMemo)(()=>{
        if (!latestNews) {
            return [];
        }
        return latestNews.pages.flatMap((page)=>page.getAllBlogPosts.data);
    }, [
        latestNews
    ]);
    const sectionsAndPosts = (0,react.useMemo)(()=>{
        var ref;
        if (!categoriesAndArticles) {
            return [];
        }
        const currentCategories = categoriesAndArticles === null || categoriesAndArticles === void 0 ? void 0 : (ref = categoriesAndArticles.pages) === null || ref === void 0 ? void 0 : ref.flatMap((page)=>page.getAllBlogCategoriesWithNestedPosts.data);
        const formattedCategoriesPath = currentCategories === null || currentCategories === void 0 ? void 0 : currentCategories.map((category)=>{
            return {
                ...category,
                id: slugify_default()((category === null || category === void 0 ? void 0 : category.name) || "", {
                    lower: true
                }),
                posts: (0,website_strapi/* websiteFormatArticleList */.o)((category === null || category === void 0 ? void 0 : category.posts) || [])
            };
        });
        return formattedCategoriesPath;
    }, [
        categoriesAndArticles
    ]);
    const formatLatestNewsPosts = (0,react.useMemo)(()=>{
        return (0,website_strapi/* websiteFormatArticleList */.o)(latestNewsSectionPosts || []);
    }, [
        latestNewsSectionPosts
    ]);
    const onLoadMore = (0,react.useCallback)(()=>{
        fetchNextPage();
    }, [
        fetchNextPage
    ]);
    const TriggerButton = (0,react.useMemo)(()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
            endAdornment: arrow_down_ForwardRef,
            className: (blog_index_module_default())["trigger-button"],
            children: "More categories"
        }), []);
    (0,use_update_header/* useUpdateHeader */.G)(contentRef, constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND);
    (0,use_clean_header/* useCleanHeader */._)();
    const featuredImage = featuredPost === null || featuredPost === void 0 ? void 0 : (ref3 = featuredPost.featuredImage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.url;
    const overwrittenMediumImage = (featuredPost === null || featuredPost === void 0 ? void 0 : (ref5 = featuredPost.featuredImage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.image) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.formats) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.overwrittenMedium) === null || ref8 === void 0 ? void 0 : ref8.url) || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (blog_index_module_default())["main-container"],
        ref: contentRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* WebsiteSeo */.P, {
                seo: SEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (blog_index_module_default())["search-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (blog_index_module_default()).title,
                        children: "Blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: onSubmit,
                        className: (blog_index_module_default())["search-bar"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar/* SearchBar */.E, {
                            id: "search",
                            onSearchClear: onSearchClear,
                            variant: "search-with-submit",
                            placeholder: "Search for articles",
                            label: "Search for article",
                            hiddenLabel: true,
                            size: "medium",
                            ...register("search")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedArticle, {
                title: (featuredPost === null || featuredPost === void 0 ? void 0 : featuredPost.title) || "",
                description: (featuredPost === null || featuredPost === void 0 ? void 0 : featuredPost.resume) || "",
                minutesRead: featuredPost === null || featuredPost === void 0 ? void 0 : featuredPost.readingTime,
                href: "/blog/".concat(categoryName, "/").concat(featuredPost === null || featuredPost === void 0 ? void 0 : featuredPost.slug),
                tag: (featuredPost === null || featuredPost === void 0 ? void 0 : (ref9 = featuredPost.category) === null || ref9 === void 0 ? void 0 : ref9.name) || "",
                picture: featuredImage || overwrittenMediumImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: (blog_index_module_default()).border
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (blog_index_module_default())["main-content"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (blog_index_module_default())["browse-category-title"],
                                children: "Browse by category"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (blog_index_module_default())["categories-container"],
                                children: [
                                    highlightedCategories.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.zx, {
                                            href: tag.href,
                                            prefetch: false,
                                            children: tag.label
                                        }, tag.label)),
                                    !isLoadingCategories && Boolean(moreOptions.items[0].items.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDropdown, {
                                        trigger: TriggerButton,
                                        ...moreOptions,
                                        side: "bottom",
                                        align: "start",
                                        sideOffset: 8
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (blog_index_module_default())["latest-news-section"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitleButton, {
                                href: "blog/latest-news",
                                children: "Latest news"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(article_list/* ArticleList */.w, {
                                className: (blog_index_module_default())["latest-news-article-list"],
                                posts: formatLatestNewsPosts
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StayInTheLoop, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (blog_index_module_default())["article-section"],
                        children: [
                            sectionsAndPosts.map((category)=>Boolean(category.posts.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitleButton, {
                                            href: "blog/".concat(category.id),
                                            children: category.name || ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(article_list/* ArticleList */.w, {
                                            className: (blog_index_module_default())["article-list"],
                                            posts: category.posts,
                                            hideThirdCard: true,
                                            onLoadMore: onLoadMore,
                                            hideCategoryTag: true
                                        })
                                    ]
                                }, "category-".concat(category.id))),
                            isFetchingNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (blog_index_module_default())["spinner-container"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                                    size: "large"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog = (Blog);
Blog.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(website_layout/* WebsiteLayout */.CG, {
        shouldChangeBgColor: true,
        headerInitialTheme: constants/* HEADER_THEMES.NEUTRAL_BACKGROUND */._.NEUTRAL_BACKGROUND,
        children: page
    });
};


/***/ }),

/***/ 86367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ez": function() { return /* binding */ useInfiniteGetAllBlogPostsQuery; }
/* harmony export */ });
/* unused harmony exports GetAllBlogPostsDocument, useGetAllBlogPostsQuery */
/* harmony import */ var _blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71285);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60431);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var libs_data_access_src_lib_custom_fetcher___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97885);
/* eslint-disable */ // @ts-nocheck



const GetAllBlogPostsDocument = /*#__PURE__*/ "\n    query GetAllBlogPosts($input: BlogPostQueryArgs!) {\n  getAllBlogPosts(input: $input) {\n    data {\n      article\n      resume\n      slug\n      title\n      readingTime\n      ...GetBlogPostBySlugAuthorFragment\n      ...GetBlogPostBySlugImageFragment\n      ...GetBlogPostBySlugTagsFragment\n      ...GetBlogPostBySlugSeoFragment\n      ...GetBlogPostBySlugCategoryFragment\n      id\n    }\n    pagination {\n      page\n      pageCount\n      pageSize\n      total\n    }\n  }\n}\n    ".concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugAuthorFragmentFragmentDoc */ .s_, "\n").concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugImageFragmentFragmentDoc */ .FD, "\n").concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugTagsFragmentFragmentDoc */ .E6, "\n").concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugSeoFragmentFragmentDoc */ .mW, "\n").concat(_blog_post_fragments_generated__WEBPACK_IMPORTED_MODULE_0__/* .GetBlogPostBySlugCategoryFragmentFragmentDoc */ .Wj);
const useGetAllBlogPostsQuery = (variables, options)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([
        "GetAllBlogPosts",
        variables
    ], (0,libs_data_access_src_lib_custom_fetcher___WEBPACK_IMPORTED_MODULE_2__/* .customFetcher */ .k)(GetAllBlogPostsDocument, variables), options);
useGetAllBlogPostsQuery.getKey = (variables)=>[
        "GetAllBlogPosts",
        variables
    ];
const useInfiniteGetAllBlogPostsQuery = (variables, options)=>{
    var _pageParam;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery)([
        "GetAllBlogPosts.infinite",
        variables
    ], (metaData)=>(0,libs_data_access_src_lib_custom_fetcher___WEBPACK_IMPORTED_MODULE_2__/* .customFetcher */ .k)(GetAllBlogPostsDocument, {
            ...variables,
            ...(_pageParam = metaData.pageParam) !== null && _pageParam !== void 0 ? _pageParam : {}
        })(), options);
};
useInfiniteGetAllBlogPostsQuery.getKey = (variables)=>[
        "GetAllBlogPosts.infinite",
        variables
    ];
useGetAllBlogPostsQuery.fetcher = (variables, options)=>(0,libs_data_access_src_lib_custom_fetcher___WEBPACK_IMPORTED_MODULE_2__/* .customFetcher */ .k)(GetAllBlogPostsDocument, variables, options);


/***/ }),

/***/ 82942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SearchBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _platform_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43287);
/* harmony import */ var _platform_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67071);
/* harmony import */ var _assets_icons_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78975);
/* harmony import */ var _assets_icons_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7556);
/* harmony import */ var _icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48031);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86565);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);







const SearchBar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { label , id , searchButtonType ="submit" , size ="medium" , variant ="live-search" , onSearchClear , onSearchSubmit , className ="" , inputClassName ="" , disabled =false , hiddenLabel =false , trackingIdentifier , shouldTrackTerms =false , ...rest } = param;
    const innerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, ()=>innerRef.current);
    (0,_platform_utils__WEBPACK_IMPORTED_MODULE_3__/* .useInputTypingEventTracking */ .a)(innerRef, _platform_utils__WEBPACK_IMPORTED_MODULE_4__/* .AmplitudeContext */ .Lq, "input_change", {
        id: trackingIdentifier,
        label
    }, shouldTrackTerms);
    const inputClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().input), (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["button-input-icons"]), {
        [(_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["has-start-adornment"])]: variant === "live-search"
    }, inputClassName);
    const renderSearchButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return variant === "search-with-submit" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            disabled: disabled,
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["search-button"]),
            onClick: onSearchSubmit,
            type: searchButtonType,
            size: size,
            variant: "default",
            icon: _assets_icons_icons__WEBPACK_IMPORTED_MODULE_7__/* .ReactComponent */ .r,
            label: "Search",
            trackingIdentifier: "Search"
        });
    }, [
        disabled,
        size,
        variant,
        onSearchSubmit,
        searchButtonType
    ]);
    const renderClearButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_button_icon_button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            disabled: disabled,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["clear-button"]), (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[size], {
                [(_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["without-search-button"])]: variant !== "search-with-submit"
            }),
            onClick: onSearchClear,
            type: "button",
            size: size,
            variant: "ghost",
            icon: _assets_icons_icons__WEBPACK_IMPORTED_MODULE_8__/* .ReactComponent */ .r,
            label: "Clear",
            trackingIdentifier: "Clear"
        });
    }, [
        disabled,
        size,
        onSearchClear,
        variant
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["input-wrapper"]), {
            [(_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["disabled-input"])]: disabled
        }, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                htmlFor: id,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label), {
                    [(_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["visually-hidden"])]: hiddenLabel
                }),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["input-container"]), (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        disabled: disabled,
                        id: id,
                        className: inputClasses,
                        ref: innerRef,
                        ...rest
                    }),
                    variant === "live-search" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons_icons__WEBPACK_IMPORTED_MODULE_7__/* .ReactComponent */ .r, {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["start-adornment"])
                    }),
                    renderSearchButton,
                    renderClearButton
                ]
            })
        ]
    });
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SearchBar)));


/***/ }),

/***/ 10912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ CTAButton; },
  "Z": function() { return /* binding */ components_button; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/src/hooks/use-event-tracking.tsx + 4 modules
var use_event_tracking = __webpack_require__(43287);
// EXTERNAL MODULE: ../../libs/utils/src/lib/amplitude/index.tsx
var amplitude = __webpack_require__(67071);
// EXTERNAL MODULE: ../../libs/utils/src/lib/helpers.ts
var helpers = __webpack_require__(44386);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/assets/icons/cta-arrow.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgCtaArrow = function SvgCtaArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.16327 15.5L6.35957 13.7887L11.0943 9.25744H0V6.74256H11.0943L6.35957 2.21875L8.16327 0.5L16 8L8.16327 15.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCtaArrow);

/* harmony default export */ var cta_arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMTYzMjcgMTUuNUw2LjM1OTU3IDEzLjc4ODdMMTEuMDk0MyA5LjI1NzQ0SDBWNi43NDI1NkgxMS4wOTQzTDYuMzU5NTcgMi4yMTg3NUw4LjE2MzI3IDAuNUwxNiA4TDguMTYzMjcgMTUuNVoiLz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/button/index.module.scss
var index_module = __webpack_require__(8579);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/button/index.tsx







const CTAButton = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { className ="" , href , variant ="highlight" , size ="large" , children , trackingIdentifier , prefetch , isExternal =false , ...rest } = param;
    const classes = classnames_default()((index_module_default()).link, (index_module_default())[variant], (index_module_default())[size], className);
    const innerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>innerRef.current);
    (0,use_event_tracking/* useClickEventTracking */.M)(innerRef, amplitude/* AmplitudeContext */.Lq, "website_button_click", {
        id: trackingIdentifier
    });
    const formattedUrl = isExternal ? href : (0,helpers/* formatUrl */.CN)(href);
    const renderChildren = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: (index_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (index_module_default())["arrow-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                        className: (index_module_default()).icon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (index_module_default())["button-label"],
                    children: children
                })
            ]
        });
    }, [
        children
    ]);
    if ((0,helpers/* isExternalUrl */.xf)(href) || isExternal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: formattedUrl,
            className: classes,
            ref: innerRef,
            ...rest,
            children: renderChildren
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: formattedUrl,
        prefetch: prefetch,
        className: classes,
        ref: innerRef,
        ...rest,
        children: renderChildren
    });
});
/* harmony default export */ var components_button = (CTAButton);


/***/ }),

/***/ 67797:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"blog_loader-container__6UbKz","main-container":"blog_main-container__HFht8","search-container":"blog_search-container__H5fEL","title":"blog_title__uE3j6","theme--light":"blog_theme--light__NsdtX","theme--dark":"blog_theme--dark__305Us","search-bar":"blog_search-bar__Py5R2","border":"blog_border__Yr7vq","main-content":"blog_main-content__T6BTW","browse-category-title":"blog_browse-category-title__jYADF","categories-container":"blog_categories-container__H_c_0","latest-news-article-list":"blog_latest-news-article-list__JbCqh","article-section":"blog_article-section__og5w3","article-list":"blog_article-list__j7rGF","spinner-container":"blog_spinner-container__CFYsv","fade-in-up":"blog_fade-in-up__kh6l9","fade-in-opacity":"blog_fade-in-opacity__1G2X_","fade-in-up-opacity":"blog_fade-in-up-opacity__QOmNO","fade-out-opacity":"blog_fade-out-opacity__qCQyG","fade-out-left":"blog_fade-out-left__vXSbt"};

/***/ }),

/***/ 11429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"menu-dropdown_content-wrapper__N5br5","container":"menu-dropdown_container__EnNR7","theme--light":"menu-dropdown_theme--light__YgqbC","theme--dark":"menu-dropdown_theme--dark__Xi1bX","group":"menu-dropdown_group__X6KGD","group-title":"menu-dropdown_group-title__Nl9Vf","items-container":"menu-dropdown_items-container__QlK0n","item":"menu-dropdown_item__xMbJU","label-container":"menu-dropdown_label-container__Xlwuv","label-content":"menu-dropdown_label-content__IS_jS","icon":"menu-dropdown_icon__iIvyp","item-text":"menu-dropdown_item-text__iFaPR","highlight":"menu-dropdown_highlight__u0F_6","description":"menu-dropdown_description__u_bCm","disabled":"menu-dropdown_disabled__j9WN7","fade-in-up":"menu-dropdown_fade-in-up__TLliH","fade-in-opacity":"menu-dropdown_fade-in-opacity__OQeyR","fade-in-up-opacity":"menu-dropdown_fade-in-up-opacity__OirRB","fade-out-opacity":"menu-dropdown_fade-out-opacity__GRnP5","fade-out-left":"menu-dropdown_fade-out-left__eKTEj"};

/***/ }),

/***/ 86565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"search-bar_input-wrapper__HbJbQ","label":"search-bar_label__ig6YI","visually-hidden":"search-bar_visually-hidden__J0xED","theme--light":"search-bar_theme--light__fSTbc","theme--dark":"search-bar_theme--dark__51du9","input-container":"search-bar_input-container__Lf_yM","input":"search-bar_input__16D_w","clear-button":"search-bar_clear-button___Vd2B","start-adornment":"search-bar_start-adornment__CnPQA","search-button":"search-bar_search-button__S_XjS","small":"search-bar_small__JUQGZ","without-search-button":"search-bar_without-search-button__cXvEc","medium":"search-bar_medium__yI0wB","button-input-icons":"search-bar_button-input-icons__ohk3R","has-start-adornment":"search-bar_has-start-adornment__DphFI","disabled-input":"search-bar_disabled-input__GeBh6","fade-in-up":"search-bar_fade-in-up__DQw5T","fade-in-opacity":"search-bar_fade-in-opacity__uJdqe","fade-in-up-opacity":"search-bar_fade-in-up-opacity__EaAUK","fade-out-opacity":"search-bar_fade-out-opacity__wX6YV","fade-out-left":"search-bar_fade-out-left__6MsZU"};

/***/ }),

/***/ 52039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link-wrapper":"category-title-button_link-wrapper__tUKDf","theme--light":"category-title-button_theme--light__5Txcr","theme--dark":"category-title-button_theme--dark__h486n","chevron-icon":"category-title-button_chevron-icon__eXXVh","large":"category-title-button_large__OTSf5","medium":"category-title-button_medium__5ZfTJ","fade-in-up":"category-title-button_fade-in-up__2lGiQ","fade-in-opacity":"category-title-button_fade-in-opacity__O0btr","fade-in-up-opacity":"category-title-button_fade-in-up-opacity__4QMCX","fade-out-opacity":"category-title-button_fade-out-opacity__hDjsq","fade-out-left":"category-title-button_fade-out-left__J0k_S"};

/***/ }),

/***/ 30024:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"styles_card-wrapper__N3yI5","picture-wrapper":"styles_picture-wrapper__y7mli","picture":"styles_picture__KogK6","picture-icon":"styles_picture-icon__aZUqe","theme--light":"styles_theme--light__75Usu","theme--dark":"styles_theme--dark__cdGge","card-content":"styles_card-content__vOGNV","tag":"styles_tag__jSIB6","min-read":"styles_min-read__C1etf","clock-icon":"styles_clock-icon__qeXLo","title":"styles_title__btHM7","description":"styles_description__auH2z","cta-button":"styles_cta-button__GyJbb","pink-graph":"styles_pink-graph__ydJAk","fade-in-up":"styles_fade-in-up__Gr0c5","fade-in-opacity":"styles_fade-in-opacity__ocbNj","fade-in-up-opacity":"styles_fade-in-up-opacity__OTYwL","fade-out-opacity":"styles_fade-out-opacity__9HDlq","fade-out-left":"styles_fade-out-left__EBvua"};

/***/ }),

/***/ 79676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-section":"styles_main-section__pClwG","theme--light":"styles_theme--light__Gd34O","theme--dark":"styles_theme--dark__WhHjk","content":"styles_content__vy_bY","title":"styles_title__eoRHY","decoration":"styles_decoration__AFQRn","paragraph":"styles_paragraph__erSAh","form":"styles_form__Mc79g","graph":"styles_graph__pOG6q","fade-in-up":"styles_fade-in-up__DhNBW","fade-in-opacity":"styles_fade-in-opacity__22LUX","fade-in-up-opacity":"styles_fade-in-up-opacity__5c_PE","fade-out-opacity":"styles_fade-out-opacity__mVb3V","fade-out-left":"styles_fade-out-left__hUky7"};

/***/ }),

/***/ 8579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"button_link__VCdDw","content":"button_content__ww7LJ","arrow-wrapper":"button_arrow-wrapper__D7KzQ","button-label":"button_button-label__2vBy5","large":"button_large__QhZHB","icon":"button_icon__ix2fV","medium":"button_medium__69Qyj","highlight":"button_highlight__5uvSX","theme--light":"button_theme--light__A2fZm","theme--dark":"button_theme--dark__NiIj7","primary":"button_primary__r9bak","secondary":"button_secondary__nR_xE","white":"button_white__Ln1lX","opacity":"button_opacity__zewbz","fade-in-up":"button_fade-in-up__4Yakx","fade-in-opacity":"button_fade-in-opacity__uiUG0","fade-in-up-opacity":"button_fade-in-up-opacity__CjxjG","fade-out-opacity":"button_fade-out-opacity__U5xnx","fade-out-left":"button_fade-out-left__QoJqj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [350,82,577,955,474,196,317,456,559,169,735,881,774,888,179], function() { return __webpack_exec__(64359); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);